export default __webpack_public_path__ + "static/media/General's Boots of Dynastic Rule.d5c8bd39.jpg";